export default __webpack_public_path__ + "static/media/avatar.24c27db3.png";